import {PlainDtoModel} from "../../../../../common/entity/dto/plain/plainDto.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsoleMaterialSummaryModel} from "../../../../material/api/entity/insoleMaterialSummary.model";

export class InsolesProviderModelMaterialModel implements PlainDtoModel{
    material: InsoleMaterialSummaryModel;
    colors: LovValueSummary[] = [];
    defaultHardness: number;
}